module.exports = __webpack_public_path__ + "img/101.4.c7c56803.png";